import dayjs from 'dayjs';
import { t } from 'i18next';
import { isNil, startCase } from 'lodash-es';

const isUUID = (str: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

const isDate = (str: string): boolean => {
  if (!str) return false;
  // ISO 8601 date format regex
  const isoDateRegex =
    /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[-+]\d{2}:?\d{2})?)?$/;
  return isoDateRegex.test(str);
};

const getReadableKey = (key: string): string => {
  switch (key) {
    case 'recurring_loads':
      return t('common.running');
    case 'load_at':
      return t('order.form.start_date');
    case 'job_start_at':
      return t('order.form.job_start_date');
    case 'zone':
      return t('order.form.order_zone');
    case 'external_id':
      return t('order.form.external_id');
    case 'po_job_number':
      return t('order.form.order_po');
    default:
      return startCase(key.replace(/_id$/, ''));
  }
};

const getReadableValue = (key: string, value: string): string => {
  if (key === 'state') {
    return startCase(value);
  }

  if (isDate(value)) {
    return dayjs(value).tz().format('MMM D, YYYY h:mm A');
  }

  if (isNil(value)) {
    return ' - ';
  }

  return value;
};

const getFormattedValues = (key: string, value: string[]): string => {
  const formattedValue = value.map((v) => getReadableValue(key, v));

  if (isUUID(formattedValue[0]) || isUUID(formattedValue[1])) {
    return t('dispatch.order_audit_log.updated');
  }

  if (formattedValue[0] === ' - ') {
    return `: ${formattedValue[1]}`;
  } else {
    return `: ${formattedValue[0]} -> ${formattedValue[1]}`;
  }
};

export const TIMELINE_EXCLUDED_KEYS = [
  'id',
  'order_id',
  'friendly_order_id',
  'delivered_quantities',
  'loads_pickup_time_minutes_avg',
  'delivered_quantity',
  'load_cycle_avg',
];

export const getFormattedObjectChange = (
  key: string,
  values: string[],
): [string, string] | null => {
  const readableKeyName = getReadableKey(key);

  if (TIMELINE_EXCLUDED_KEYS.includes(key)) {
    return null;
  }

  return [readableKeyName, getFormattedValues(key, values)];
};
